import _defineProperty from '../../node_modules/@babel/runtime/helpers/defineProperty.js';
import btn from '../styles/btn.js';
import { button } from '../styles/elements/button.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var btnReset = _objectSpread(_objectSpread(_objectSpread({}, button), btn.button), {}, {
  overflowX: 'visible',
  overflowY: 'visible',
  whiteSpace: 'normal',
  '&:hover': {
    background: 'inherit'
  },
  '&:active': {
    background: 'inherit'
  }
});

export default btnReset;
